import React, { useState, useEffect } from 'react';
import DynamicSections from '../../components/DynamicSections';
import CtaBanner from '../../components/CtaBanner';
import TOC from '../../components/TOC';
import StickyCta from '../../components/StickyCta';
import Popup from '../../components/Popup';
import getAllReviews from '../../api/queries/reviews/getAllReviews';
import createApolloClient from '../../api';

const Article = ({ data, headings, customReviewsData }) => {
  const articleData = data.articleBy;
  const { sections } = articleData.sections;
  const { title } = articleData;
  const { banner } = articleData;

  return (
    <div className="article">
      <h1>{title}</h1>
      {banner.headingDescription && <p>{banner.headingDescription}</p>}
      <TOC headings={headings} />
      <CtaBanner content={banner} customReviewsData={customReviewsData} />
      <DynamicSections sections={sections} />
      <StickyCta />
      <Popup />
    </div>
  );
};

export default Article;

export async function getStaticProps() {
  const client = createApolloClient();
  const customReviewsData = await client.query(getAllReviews());
  return { props: { customReviewsData } };
}
